import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getFinancialPackageFromHeSchool = ({
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/college-cost/financial-package/retrieve-from-he-school/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFinancialPackage = ({ uuid, student, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/financial-package/${uuid}/`,
      method: RequestMethod.GET,
      params: { student },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFinancialPackageList = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/financial-package/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getLineItemContext = ({ student, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/line-item-context/`,
      method: RequestMethod.GET,
      params: { student },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createLineItem = ({ payload, student, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/line-item/`,
      method: RequestMethod.POST,
      params: { student },
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const uploadFinancialPackageImage = ({
  payload,
  student,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/college-cost/image/`,
      method: RequestMethod.POST,
      params: { student },
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteLineItem = ({ uuid, student, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/line-item/${uuid}/`,
      method: RequestMethod.DELETE,
      params: { student },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const verifyAwardLetter = ({ uuid, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/award-letter-verifications/${uuid}/verify/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const unverifyAwardLetter = ({ uuid, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/award-letter-verifications/${uuid}/unverify/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const declineAwardLetter = ({ uuid, payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/award-letter-verifications/${uuid}/decline/`,
      data: payload,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAwardLetterList = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/award-letter-verifications/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAwardLetterVerificationCounts = ({
  params = {},
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/college-cost/award-letter-verifications/counts/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAwardLetterVerificationVerifiers = ({
  params = {},
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/college-cost/award-letter-verifications/k12-admins/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCollegeCostSettings = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/settings/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAwardTypes = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/line-item-presets/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const exportCollegeCostEarningCSV = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/college-cost/award-letter-verifications/college-cost-earnings-csv/`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const exportThirdPartyScholarshipAwardedCSV = ({
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/college-cost/award-letter-verifications/third-party-scholarship-awarded-csv/`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const exportAwardLetterBreakdownCSV = ({
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/college-cost/award-letter-verifications/award-letter-breakdown-csv/`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
